import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [, setVerifying] = useState(true);
  const [, setVerified] = useState(false);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Optional: Verify the payment with your backend
    const verifyPayment = async () => {
      if (sessionId) {
        try {
          // You could verify the payment here if needed
          console.log('Payment session:', sessionId);
          setVerified(true);
        } catch (error) {
          console.error('Verification error:', error);
        }
      }
      setVerifying(false);
    };

    verifyPayment();
  }, [sessionId]);

  return (
    <div className="payment-result-page">
      <div className="payment-result-container">
        <div className="success-animation">
          <div className="success-checkmark">✓</div>
        </div>
        
        <h1>Thank You! 🎉</h1>
        <p className="success-message">
          Your support means the galaxy to us!
        </p>
        
        <div className="success-details">
          <p>Your payment has been successfully processed.</p>
          <p>You're helping us keep ForceSight free and continuously improving.</p>
        </div>

        <div className="success-actions">
          <button 
            className="primary-button"
            onClick={() => navigate('/dashboard')}
          >
            Return to Dashboard
          </button>
          <button 
            className="secondary-button"
            onClick={() => navigate('/')}
          >
            Go Home
          </button>
        </div>

        {sessionId && (
          <div className="session-info">
            <small>Reference: {sessionId.substring(0, 20)}...</small>
          </div>
        )}
      </div>

      <style jsx>{`
        .payment-result-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          background: var(--space-gradient);
        }

        .payment-result-container {
          background: rgba(0, 0, 0, 0.8);
          border: 2px solid var(--force-cyan);
          border-radius: 16px;
          padding: 3rem;
          max-width: 500px;
          width: 100%;
          text-align: center;
          box-shadow: 0 20px 40px rgba(0, 212, 255, 0.3);
        }

        .success-animation {
          margin-bottom: 2rem;
        }

        .success-checkmark {
          width: 80px;
          height: 80px;
          margin: 0 auto;
          background: var(--yoda-green);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 3rem;
          color: white;
          animation: scaleIn 0.5s ease-out;
          box-shadow: 0 0 30px rgba(0, 170, 0, 0.6);
        }

        @keyframes scaleIn {
          0% {
            transform: scale(0);
            opacity: 0;
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }

        h1 {
          color: var(--force-cyan);
          font-family: var(--font-display);
          font-size: 2.5rem;
          margin: 1rem 0;
          animation: fadeInUp 0.6s ease-out 0.2s both;
        }

        .success-message {
          color: var(--yoda-green);
          font-size: 1.2rem;
          margin: 1rem 0;
          font-weight: bold;
          animation: fadeInUp 0.6s ease-out 0.3s both;
        }

        .success-details {
          margin: 2rem 0;
          animation: fadeInUp 0.6s ease-out 0.4s both;
        }

        .success-details p {
          color: var(--gray-300);
          margin: 0.5rem 0;
          line-height: 1.6;
        }

        .success-actions {
          display: flex;
          gap: 1rem;
          justify-content: center;
          margin-top: 2rem;
          animation: fadeInUp 0.6s ease-out 0.5s both;
        }

        .primary-button {
          background: var(--jedi-blue);
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 8px;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .primary-button:hover {
          background: var(--force-cyan);
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 212, 255, 0.4);
        }

        .secondary-button {
          background: transparent;
          color: var(--force-cyan);
          border: 2px solid var(--force-cyan);
          padding: 0.75rem 1.5rem;
          border-radius: 8px;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .secondary-button:hover {
          background: rgba(0, 212, 255, 0.1);
          transform: translateY(-2px);
        }

        .session-info {
          margin-top: 2rem;
          padding-top: 2rem;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          animation: fadeInUp 0.6s ease-out 0.6s both;
        }

        .session-info small {
          color: var(--gray-500);
          font-family: monospace;
        }

        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 640px) {
          .payment-result-container {
            padding: 2rem;
          }

          h1 {
            font-size: 2rem;
          }

          .success-actions {
            flex-direction: column;
          }

          .primary-button,
          .secondary-button {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default PaymentSuccess;